import React from 'react';
import {FicheAutoControleCritere} from '../../../store/types/FicheAutocontrole.Types';
import {TextField} from '@material-ui/core';
import { LabelCritereAutocontroleStyled, SwitchAutocontroleStyled } from '../../../styles/CritereAutocontrole.style';
import SwitchIconDefault from "./../../../assets/value-indicator-default.svg";
import { ApplicationState } from '../../../store/store/store';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { GoBackCurrentState, GoBackCurrentStateActions } from '../../../store/types/GoBackState.Types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import InfoPhoto from '../../../assets/info_photo.svg'
import { ModeAffichage, TYPE_CRITERE_COMMENTAIRE } from '../../../utils/constantes/contantes';
import { CritereUtils } from '../CritereUtils';

interface PropsFromState {
    critere:FicheAutoControleCritere,
    updateCritere: Function,
    modeAffichage?: ModeAffichage
}

interface PropsFromDispatch {
    goBackStateHasChanged: Function,
    goBackState: GoBackCurrentState
}

type AllProps = PropsFromDispatch & PropsFromState

const InputTextAutocontrole: React.FC<AllProps> = ({modeAffichage, critere, updateCritere, goBackStateHasChanged, tabSynthese}) => {
    let maxValue:number = 3000;
    const history = useHistory();
    maxValue = (critere.id === 'c_commcmq') ? maxValue : 250;
    const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
        critere.activated = event.target.checked;
        updateCritere(critere);
    };

    const handleChangeInputText = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        goBackStateHasChanged();
        if(((event.target as HTMLInputElement).value as unknown as string).length <= maxValue){
            critere.value = (event.target as HTMLInputElement).value as unknown as string;
            updateCritere(critere);
        }else{
            critere.value = ((event.target as HTMLInputElement).value as unknown as string).slice(0, maxValue);
            updateCritere(critere);
        }
    };

    
const isIT = critere.typeCriteria === TYPE_CRITERE_COMMENTAIRE;
const isActive = CritereUtils.getActiveStateFromCriteriaTab(critere, modeAffichage);
const isMaxLength = (critere.value as string).length === maxValue;

return (
  <div>
    <div className="commentary-flex">
      {isIT && (
        <img
          className="icon-libelle margin-commentary"
          src={InfoPhoto}
          alt=""
          onClick={() => history.push('/rgpd?mode=info')}
        />
      )}

      <LabelCritereAutocontroleStyled>
        {critere.title}
        {isActive && (
          <SwitchAutocontroleStyled
            className="elt-float-right"
            checked={critere.activated}
            onChange={handleChangeSwitch}
            icon={<img src={SwitchIconDefault} alt="" />}
          />
        )}
      </LabelCritereAutocontroleStyled>
    </div>

    <div>
      <div className="critera-input-text-box">
        <TextField
          className="critera-input-text"
          value={critere.value}
          onChange={handleChangeInputText}
          placeholder={isIT ? "Ecrivez votre commentaire ici..." : undefined}
          helperText={isMaxLength ? "Vous avez atteint la limite du nombre de caractères." : ""}
          error={isMaxLength}
          disabled={!critere.activated}
          multiline
        />
      </div>
    </div>
  </div>
);
    
};
  

const mapStateToProps = ({ goBackState }: ApplicationState) => ({
    goBackState: goBackState
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        goBackStateHasChanged: () => dispatch({ type: GoBackCurrentStateActions.CHANGING_STATE})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InputTextAutocontrole);